import { render } from "./unbind.vue?vue&type=template&id=52291efd"
import script from "./unbind.vue?vue&type=script&lang=js"
export * from "./unbind.vue?vue&type=script&lang=js"

import "./unbind.vue?vue&type=style&index=0&id=52291efd&lang=less"
script.render = render

export default script